import { GrabsonIcon } from "components/layout";
import { ReleaseStage, STATUS_LABELS } from "hooks/tivoApps";
import { classes } from "utils/classes";

import { TEXTS } from "../constants";
import styles from "./PublicationStatus.scss";

export interface PublicationStatusProps {
  variantReleaseStages?: ReleaseStage[];
  applicableReleaseStages?: ReleaseStage[];
  publication?: ReleaseStage[];
  releaseStage: ReleaseStage;
  isTargetValid?: boolean;
}

export const PublicationStatus = ({
  variantReleaseStages = [],
  applicableReleaseStages = [],
  publication = [],
  releaseStage,
  isTargetValid = true,
}: PublicationStatusProps) => {
  const rsAvailableOnOem = applicableReleaseStages.includes(releaseStage);
  const published = publication?.includes(releaseStage) || false;
  const available =
    variantReleaseStages.includes(releaseStage) && isTargetValid;

  const statusIcon = published
    ? "ok"
    : (available || !isTargetValid) && rsAvailableOnOem
      ? "minus"
      : "close";

  return (
    <GrabsonIcon
      name={statusIcon}
      className={classes({
        [styles.published]: published && available,
        [styles.notPublished]: !published && available,
        [styles.notAvailable]: !available,
        [styles.notValidTarget]: !isTargetValid,
        // !published check is only for legacy data or configurational errors in OEM Form. In normal scenario Variant would not be published on unavailable OEM
        [styles.notAvailableOnOem]: !published && !rsAvailableOnOem,
      })}
      title={STATUS_LABELS[releaseStage] || TEXTS.DEFAULT_RELEASE_STAGE}
      size="lg"
      dataTestId={`${releaseStage}-${available ? "" : "not-"}available-${published ? "" : "not-"}published`}
    />
  );
};
